//按日配送频次
import React, { Component } from 'react';
import { InputNumber } from 'antd';
export default class MiniTime extends Component {
  constructor(props) {
    super(props);
    this.state={
      value:props.values,
      formatter:value => {if (value!==null && value !==undefined&& value !==""){return `${value}小时`}else{return null}}
    }
  }
  componentDidMount() {
    if (this.props.model)
      this.props.model.addListener(this);
    setTimeout(() => {
      this.handleBlur()
    }, 20);
  }
  handleFocus = ()=>{
    this.setState({
      formatter:(value)=>{return value}
    })
  }
  handleBlur=()=>{
    this.setState({
      formatter:value => {if (value!==null && value !==undefined&& value !==""){return `${value}小时`}else{return null}}
    })
  }
  handleChange=(value)=>{
    this.setState({value:value ||null})
    this.props.handleChange(value)
  }
  render() {
    let  {mode} =this.props;
    let _values =  this.props.model.getCellValue(5,'values')
    if(mode=='browse'){
      let _val = this.props.model.getCellValue(5,'values')
      return <div>
        {_val + "小时"}
      </div>
    }
    return (
      <InputNumber
        defaultValue={this.state.value}
        value = {this.state.value}
        onFocus={e => this.handleFocus(e)}
        onBlur={e => this.handleBlur(e)}
        onChange={(value)=>this.handleChange(value)}
        precision={1}
        min={0}
        className={"upc-minitime"}
        formatter={this.state.formatter}
        parser={value => value.replace('小时', '')}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/formatter/MiniTime.jsx